import { CustomImage, CustomTable, useText, Text } from '@src/components';
import React, { useCallback, useState, useEffect } from 'react';
import { useLang } from '@src/context';
import '@src/styles/companyInformation/deliveryAdresses/deliveryAdressesList.scss';
import { Button, Dropdown, Menu } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import iconFilterNew from '@src/assets/icons/icon-filter-new.svg';
import { DownCircleOutlined, UpCircleOutlined, MoreOutlined } from '@ant-design/icons';
import { postBalanceTransferReport } from '@src/store/slice/balanceUploadDetailSlice';
import FilterMenu from './FilterMenu';
import balanceUploadDetailServices from '@src/services/balanceUploadDetail.services';
import download from 'js-file-download';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import { getFileNameByLanguage } from '@src/utils/utils';
function getExpandIcon() {
  return ({ expanded, onExpand, record }) =>
    expanded ? (
      <UpCircleOutlined style={{ fontSize: '24px' }} onClick={(e) => onExpand(record, e)} />
    ) : (
      <DownCircleOutlined style={{ fontSize: '24px' }} onClick={(e) => onExpand(record, e)} />
    );
}

const UploadedBalanceTransferReportList = () => {
  const [expandedRows, setExpandedRows] = useState([]);
  const { selectedCustomer } = useSelector((state) => state?.customer);
  const dispatch = useDispatch();
  const { balancesReportList } = useSelector((state) => state?.balanceUploadDetail);
  const { language } = useLang();

  useEffect(() => {
    loadAdressList();
  }, [language]);

  const loadAdressList = useCallback(
    async (filter) => {
      await dispatch(
        postBalanceTransferReport({
          customerId: selectedCustomer?.customerId,
          type: 1,
          sourceRefId: null,
          targetRefId: null,
          sourceCardNumber: null,
          targetCardNumber: null,
          startDate: null,
          endDate: null,
        }),
      );
    },
    [dispatch],
  );

  const columns = [
    {
      title: '#',
      dataIndex: 'index',
      key: 'receiverName',
      width: 20,
      align: 'left',
      render: (text, record, index) => {
        return (
          <div>
            <span>{index + 1}</span>
          </div>
        );
      },
    },
    {
      title: (
        <div
          style={{
            wordBreak: 'break-word',
            whiteSpace: 'normal',
          }}
        >
          <Text t="date" />
        </div>
      ),
      dataIndex: 'transferDate',
      key: 'transferDate',
      align: 'center',
      width: 35,
      className: 'custom-index-column',
      ellipsis: true,
      sorter: (a, b) => {
        const dateA = new Date(a.transferDate);
        const dateB = new Date(b.transferDate);
        return dateA - dateB;
      },
    },
    {
      title: (
        <div
          style={{
            wordBreak: 'break-word',
            whiteSpace: 'normal',
          }}
        >
          <Text t="senderCardNo" />
        </div>
      ),
      dataIndex: 'sourceCardNumber',
      key: 'sourceCardNumber',
      width: 50,
      align: 'left',
      sorter: (a, b) => {
        const numA = parseFloat(a.sourceCardNumber);
        const numB = parseFloat(b.sourceCardNumber);
        if (!isNaN(numA) && !isNaN(numB)) {
          return numA - numB;
        }
        return a.sourceCardNumber.localeCompare(b.sourceCardNumber);
      },
    },
    {
      title: (
        <div
          style={{
            wordBreak: 'break-word',
            whiteSpace: 'normal',
          }}
        >
          <Text t="senderReferenceNo" />
        </div>
      ),
      dataIndex: 'sourceRefId',
      key: 'sourceRefId',
      width: 40,
      align: 'left',
      sorter: (a, b) => {
        const numA = parseFloat(a.sourceRefId);
        const numB = parseFloat(b.sourceRefId);
        if (!isNaN(numA) && !isNaN(numB)) {
          return numA - numB;
        }
        return a.sourceRefId.localeCompare(b.sourceRefId);
      },
    },
    {
      title: (
        <div
          style={{
            wordBreak: 'break-word',
            whiteSpace: 'normal',
          }}
        >
          <Text t="senderCardStatus" />
        </div>
      ),
      dataIndex: 'cardStatus',
      key: 'cardStatus',
      width: 40,
      align: 'left',
      responsive: ['xl'],
      sorter: (a, b) => a.cardStatus.localeCompare(b.cardStatus),
    },
    {
      title: (
        <div
          style={{
            wordBreak: 'break-word',
            whiteSpace: 'normal',
          }}
        >
          <Text t="recipientCardNo" />
        </div>
      ),
      dataIndex: 'targetCardNumber',
      key: 'targetCardNumber',
      align: 'left',
      width: 45,
      className: 'custom-index-column',
      ellipsis: true,
      sorter: (a, b) => {
        const numA = parseFloat(a.targetCardNumber);
        const numB = parseFloat(b.targetCardNumber);
        if (!isNaN(numA) && !isNaN(numB)) {
          return numA - numB;
        }
        return a.targetCardNumber.localeCompare(b.targetCardNumber);
      },
    },
    {
      title: (
        <div
          style={{
            wordBreak: 'break-word',
            whiteSpace: 'normal',
          }}
        >
          <Text t="recipientReferenceNo" />
        </div>
      ),
      dataIndex: 'targetRefId',
      key: 'targetRefId',
      align: 'left',
      width: 45,
      className: 'custom-index-column',
      ellipsis: true,
      sorter: (a, b) => {
        const numA = parseFloat(a.targetRefId);
        const numB = parseFloat(b.targetRefId);
        if (!isNaN(numA) && !isNaN(numB)) {
          return numA - numB;
        }
        return a.targetRefId.localeCompare(b.targetRefId);
      },
    },
    {
      title: (
        <div
          style={{
            wordBreak: 'break-word',
            whiteSpace: 'normal',
          }}
        >
          <Text t="amount2" />
        </div>
      ),
      dataIndex: 'orderAmount',
      key: 'orderAmount',
      align: 'left',
      width: 45,
      className: 'custom-index-column',
      ellipsis: true,
    },
    {
      title: (
        <div
          style={{
            wordBreak: 'break-word',
            whiteSpace: 'normal',
          }}
        >
          <Text t="orderNoUpperCase" />
        </div>
      ),
      dataIndex: 'orderNumber',
      key: 'orderNumber',
      align: 'left',
      width: 45,
      className: 'custom-index-column',
      ellipsis: true,
    },
    {
      title: (
        <div
          style={{
            wordBreak: 'break-word',
            whiteSpace: 'normal',
          }}
        >
          <Text t="orderStatus2" />
        </div>
      ),
      dataIndex: 'orderStatus',
      key: 'orderStatus',
      align: 'left',
      width: 45,
      className: 'custom-index-column',
      ellipsis: true,
      render: (text, record, index) => {
        return (
          <div>
            <span
              style={
                record.orderStatus === 'Kredi Üretildi'
                  ? {
                    color: '#027a48',
                    backgroundColor: '#d1fadf',
                    borderRadius: '32px',
                    padding: '8px 12px',
                  }
                  : {
                    color: '#c3410d',
                    backgroundColor: '#fff4e6',
                    borderRadius: '32px',
                    padding: '8px 12px',
                  }
              }
            >
              {record.orderStatus === 'Kredi Üretildi' ? 'Krediler Üretildi' : 'Üretim Aşamasında'}
            </span>
          </div>
        );
      },
    },
  ];
  const getPDFFile = async () => {
    const data = await balanceUploadDetailServices.balanceTrasferReportGetPDFFile({
      customerId: selectedCustomer?.customerId,
      segmentId: 100,
    });
    download(
      data,
      `${getFileNameByLanguage('bakiye-transfer-raporu', 'balance-transfer-report')}-${dayjs().format('DD-MM-YYYY hh:mm')}.pdf`,
    );
  };

  const getExcelFile = async () => {
    const data = await balanceUploadDetailServices.balanceTrasferReportGetExcelFile({
      customerId: selectedCustomer?.customerId,
      segmentId: 100,
    });
    download(
      data,
      `${getFileNameByLanguage('bakiye-transfer-raporu', 'balance-transfer-report')}-${dayjs().format('DD-MM-YYYY hh:mm')}.xlsx`,
    );
  };
  const DownloadMenu = (
    <Menu>
      <Menu.Item onClick={getExcelFile}>
        <Text t="downloadReportExcel" />{' '}
      </Menu.Item>
      <Menu.Item onClick={getPDFFile}>
        <Text t="downloadReportPdf" />
      </Menu.Item>
    </Menu>
  );
  return (
    <div className="user-list-card">
      <div
        style={{
          fontFamily: 'UbuntuMedium',
          fontSize: '18px',
          color: '#050505',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginLeft: '24px',
          marginRight: '16px',
          paddingTop: '15px',
          paddingBottom: '15px',
        }}
      >
        <div>
          <Text t="balanceTransferReport" />
        </div>
        <div style={{ display: 'flex', gap: '12px' }}>
          <Dropdown overlay={<FilterMenu />} trigger={['click']}>
            <Button
              type="text"
              icon={<CustomImage src={iconFilterNew} />}
              style={{
                borderRadius: '25%',
                padding: '10px',
                borderColor: '#f1f5f9',
                backgroundColor: ' #f2f5f7',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 'auto',
                height: 'auto',
              }}
            />
          </Dropdown>
          <Dropdown overlay={DownloadMenu} trigger={['click']}>
            <Button
              style={{
                borderRadius: '25%',
                padding: '10px',
                borderColor: '#f1f5f9',
                backgroundColor: ' #f2f5f7',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 'auto',
                height: 'auto',
              }}
              shape="circle"
              icon={<MoreOutlined />}
            />
          </Dropdown>
        </div>
      </div>
      <CustomTable
        isScroll={false}
        expandedRowKeys={expandedRows}
        expandable={{
          showExpandColumn: false,
          expandIconColumnIndex: 11,
          onExpand: (expanded, record, key) =>
            expandedRows === key ? setExpandedRows(null) : setExpandedRows(key),
          expandIcon: getExpandIcon(),
        }}
        pagination={false}
        dataSource={balancesReportList}
        columns={columns}
        className="user-list-table"
        rowKey={(record) => record?.id}
      />
    </div>
  );
};

export default UploadedBalanceTransferReportList;

getExpandIcon.propTypes = {
  expanded: PropTypes.any,
  onExpand: PropTypes.any,
  record: PropTypes.any,
};
